import { createIcon } from '@chakra-ui/icons';

export const Minus = createIcon({
  displayName: 'Minus',
  viewBox: '0 0 24 4',
  d: 'M22.2857 3.42857H1.71429C1.25963 3.42857 0.823594 3.24796 0.502103 2.92647C0.180612 2.60498 0 2.16894 0 1.71429C0 1.25963 0.180612 0.823594 0.502103 0.502103C0.823594 0.180612 1.25963 0 1.71429 0H22.2857C22.7404 0 23.1764 0.180612 23.4979 0.502103C23.8194 0.823594 24 1.25963 24 1.71429C24 2.16894 23.8194 2.60498 23.4979 2.92647C23.1764 3.24796 22.7404 3.42857 22.2857 3.42857Z',
});
